import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import GameRoutes from "./routes";
import { initTelegram } from "./utils/telegram";
import "./styles/auth.css";
import "./styles/style.css";

// Polyfill for requestIdleCallback (iOS/Safari compat)
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };

import ErrorBoundary from "./components/ErrorBoundary";


// Global Error Handler for Mobile Debugging
window.onerror = function (message, source, lineno, colno, error) {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    alert(`Error: ${message}\nSource: ${source}\nLine: ${lineno}\nStack: ${error ? error.stack : 'N/A'}`);
  }
};

const container = document.getElementById("app");

if (!container) {
  throw new Error("Failed to find the root element");
}

// Initialize Telegram Web App
initTelegram().catch(err => console.error("Telegram Init Failed:", err));
if (window.Telegram?.WebApp) {
  window.Telegram.WebApp.expand();
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <GameRoutes />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
